import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, switchMap, tap, map, catchError, of, startWith, Subscription } from 'rxjs';
import { DataState } from '../../../model/dataState';
import { Verification } from '../../../services/verification';
import country from 'country-state-city/lib/country';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CanonSearchDialog } from '../canon-search-dialog/canon-search-dialog';
import { NavStateService } from '../../../services/nav-state.service';
import { VerificationPatchService } from '../../../services/verification-patch-service';
import { SuccessDialog } from '../../common-features/success-dialog/success-dialog';
import { FormControl } from '@angular/forms';
interface QueryParams {
  page: number;
  size: number;
  status: string;
  country: string;
  companyName: string;
  sortOrder: string;
}
@Component({
  selector: 'app-audit-list',
  standalone: false,
  templateUrl: './audit-list.html',
  styleUrl: './audit-list.less',
})
export class AuditList implements OnInit, OnDestroy {
  private verificationService = inject(Verification);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private matDialog = inject(MatDialog);
  private navState = inject(NavStateService);
  @Output() moveToVerificationForm = new EventEmitter<any>();
  @Output() canonSearch = new EventEmitter<any>();
  @Output() createCanonForm = new EventEmitter<any>();
  private transferService = inject(VerificationPatchService);
  private subStream!: Subscription;
  pagination$ = new BehaviorSubject<QueryParams>({
    page: 0,
    size: 10,
    status: '',
    country: '',
    companyName: '',
    sortOrder: 'asc',

  });
  searchTerm: string = '';
  verificationList$!: Observable<DataState<any[]>>;
  currentPage = 1;
  pageSize = 10;
  start:number = 0;
  end:number =0;
  totalRecord:number = 0;
  sortOrder: string = 'asc';
  countryList = country.getAllCountries();
  sortKey: string = '';
  totalPages = 0;
  pages: any[] = [];
  record: any;
  stats = {
    pending: 34,
    inReview: 18,
    completed: 195,
    spend: 4850
  };

  filteredCountries$!: Observable<any[]>;
  countrySearchControl = new FormControl('');

  constructor() { }

  ngOnInit(): void {
    this.navState.setCurrentTitle('Audit List');
    this.navState.setShowBackButton(false);
    this.subStream = this.transferService.activeRecord$.subscribe({
      next: (data: any) => {
        if (data) {
          this.patchRequest(this.record, data);
        }

      }
    });
    this.verificationList$ = this.pagination$.pipe(
      switchMap((params) => {
        this.currentPage = params.page;
        this.pageSize = params.size;
        return this.verificationService.getAuditQueue(params.page*params.size, params.size, params.status, params.country, params.companyName, params.sortOrder).pipe(
          tap((response: any) => {
            if (response) {
              this.totalRecord = response.total;
              this.totalPages = Math.ceil(response.total / this.pageSize);
              this.pages = Array.from({ length: this.totalPages }, (_, i) => i)
              this.start = this.currentPage * this.pageSize +1;
              this.end = (this.currentPage + 1) * this.pageSize;
              if (this.end > this.totalRecord){
                this.end = this.totalRecord;
              }
            }

          }),
          map((response: any) => ({
            loading: false,
            error: null,
            data: response.result
          }
          )),
          catchError((error) => of({
            loading: false,
            error: error,
            data: null
          })),
          startWith({
            loading: true,
            error: null,
            data: null
          })
        )
      })
    )

     this.filteredCountries$ = this.countrySearchControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
    
    // 4. Pre-fill the input field text if a country filter is active by default
    const initialCountry = this.pagination$.value.country || '';
    this.countrySearchControl.setValue(initialCountry, { emitEvent: false });
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.countryList.filter(country => 
      country.name.toLowerCase().includes(filterValue)
    );
  }

  startVerificationWorkflow(): void {
    // console.log('Routing execution step to Company Details Form component view...');
    // this.router.navigate(['/verification/verification-form'])
    this.moveToVerificationForm.emit()
  }

  downloadReport(recordId: string): void {
    // console.log(`Downloading compiled evaluation sheet or raw certificate for execution packet ${recordId}`);
  }

  onPageChange(newPage: number) {
    if (newPage < 0 || newPage > this.totalPages) {
      return;
    }
    this.pagination$.next({
      ...this.pagination$.value,
      page: newPage,
      size: this.pageSize
    })
  }

  onCountryChange(country: string) {
    this.pagination$.next({
      ...this.pagination$.value,
      country: country
    })
  }

  onStatusChange(status: string) {
    this.pagination$.next({
      ...this.pagination$.value,
      status: status
    })
  }

  onCompanyNameChange(companyName: string) {
    this.pagination$.next({
      ...this.pagination$.value,
      companyName: companyName
    })
  }

  onSortOrderChange(sortOrder: string): void {
    this.pagination$.next({
      ...this.pagination$.value,
      sortOrder: sortOrder
    })
  }

  resetSearch(){
    this.pagination$.next({
      page: 0,
      size: 10,
      status: '',
      country: '',
      companyName: '',
      sortOrder: 'asc',
    })
  }

  createCofanetForm(record: any) {
    // console.log(record)
    this.router.navigate(['canon-form'], {
      relativeTo: this.route,
      state: {
        record: record
      },
    })
  }

  mapCofanetForm(record: any) {
    this.record = record;
    this.canonSearch.emit(record);
    console.log(record)
    // let searchDialog = this.matDialog.open(CanonSearchDialog,{
    //     data:{record:record},
    //     width:'500px'
    // })

    // searchDialog.afterClosed().subscribe((result:any)=>{
    //   if(result){
    //     console.log(result)
    //     this.patchRequest(record,result)
    //   }
    // })
  }

  patchRequest(record: any, result: any) {
    console.log(record);
    console.log(result)
    const form = {

      "id": record.id,
      "companyName": record.companyName,
      "country": record.country,
      "companyType": record.companyType,
      "requestCount": record.requestCount,
      "registeredAddress": record.registeredAddress,
      "registrationType": record.registrationType,
      "registrationId": record.registrationId,
      "creditRecommendation": record.creditRecommendation,
      "assessmentComments": record.assessmentComments,
      "riskRating": record.riskRating,
      "cofanetReceipt": record.cofanetReceipt,

    }
    this.verificationService.patchAuditRequest(record.parentRequestId, 'SUCCESS', '', result.id, form)
      .subscribe({
        next: (data: any) => {
          this.patchVerificationRequest(record, 'SUCCESS');
          this.pagination$.next({
            ...this.pagination$.value,
            page: 0,
            size: this.pageSize,
          })
        },
        error: (err: any) => {
          console.log(err)
        }
      })
  }

  // onStatusUpdate(record: any, newStatus: string) {
  //   this.verificationService.patchAuditRequest(record.id, newStatus, '', '', record)
  //     .subscribe({
  //       next: (response: any) => {
  //         console.log('Status updated successfully:', response);
  //         this.pagination$.next({
  //           ...this.pagination$.value
  //         });
  //       },
  //       error: (err: any) => {
  //         console.log('Error updating status:', err);
  //       }
  //     });
  // }

  // handleFinalPatchRequest(selectedRecord: any) {
  //   this.patchRequest(this.record, selectedRecord)
  // }

  ngOnDestroy(): void {
    if (this.subStream) {
      this.subStream.unsubscribe();
    }
  }

  onStatusUpdate(record: any, status: any) {
    console.log(status)
    let confirmFail = 'false'
    if (status == 'FAILED') {
      confirmFail = 'true'
    }
    const form = {
      "id": record.id,
      "companyName": record.companyName,
      "registeredAddress": record.registeredAddress,
      "country": record.country,
      "companyType": record.companyType,
      "requestCount": record.requestCount,
      "registrationType": record.registrationType,
      "registrationId": record.registrationId,
      "creditRecommendation": record.creditRecommendation,
      "assessmentComments": record.assessmentComments,
      "riskRating": record.riskRating,
      "cofanetReceipt": record.cofanetReceipt,
    }
    this.verificationService.patchAuditRequest(record.parentRequestId, status, confirmFail, record.canonId, form)
      .subscribe({
        next: (response: any) => {
          console.log('Status updated successfully:', response);
          this.patchVerificationRequest(record, status);
          this.pagination$.next({
            ...this.pagination$.value
          });
        },
        error: (err: any) => {
          console.log('Error updating status:', err);
          this.showSuccessAndErrorDialog('Error', 'Could not update the status ', 'error');
        }
      });
  }

  patchVerificationRequest(record: any, status: string) {
    this.getVerificationById(record.parentRequestId)
      .pipe(
        switchMap((parentRecord: any) => {
          const form = {
            ...parentRecord,
            requestStatus: status,
          };
          return this.verificationService.patchVerificationRequest(parentRecord?.id, form);
        })
      )
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.showSuccessAndErrorDialog('SUCCESS', 'Status updated successfully', 'success');
        },
        error: (err: any) => {
          console.error(err);
          this.showSuccessAndErrorDialog('Error', 'Status could not be updated. Please contact admin.', 'error');
        }
      });
  }

  getVerificationById(id: any) {
    return this.verificationService.getVerificationById(id)

  }

  showSuccessAndErrorDialog(title: any, message: any, icon: any) {
    const dialog = this.matDialog.open(SuccessDialog, {
      disableClose: true,
      width: '500px',
      data: {
        title: title,
        subtitle: message,
        icon: icon
      },
    })
    dialog.afterClosed().subscribe(result => {

    })
  }

  addCanonRecord(record: any) {
    this.createCanonForm.emit(record);
  }
}
